import { AppRouter } from './routes/AppRouter';
import './styles/globals.css';

function App() {
  return <AppRouter />;
}

export default App;
